import classNames from 'classnames';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import { FC, useCallback, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import styles from './VerticalFAQ.module.scss';

interface Props {
  contents: string;
  title: string;
}

export const VerticalFAQItem: FC<Props> = ({ contents, title }) => {
  const [isOpen, setOpen] = useState(false);

  const handleToggle = useCallback(() => {
    setOpen((value) => !value);
  }, []);

  const height = isOpen ? 'auto' : 0;

  return (
    <div className={classNames(styles['collapsible-container'])}>
      <button
        data-test-id={'dataTestId'}
        className={classNames(styles['heading-button'])}
        onClick={handleToggle}
      >
        <h3>{title}</h3>
        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </button>

      <AnimateHeight duration={300} height={height} className={styles['animate-height']}>
        <div data-test-id={`${'dataTestId'}-content`} className={styles['content']}>
          {contents}
        </div>
      </AnimateHeight>
    </div>
  );
};

export default VerticalFAQItem;
export type { Props as VerticalFAQItemProps };
